import { Badge } from '@chakra-ui/react';
import type { OrderRewardSnapshot } from '@fluenceur/types';
import { useTranslation } from 'react-i18next';

export function OrderRewardBadge({ snapshot }: { snapshot?: OrderRewardSnapshot | null }) {
  const { t } = useTranslation();
  if (snapshot?.kind !== 'customer_first_order' && snapshot?.kind !== 'pending_verification')
    return null;
  const pending = snapshot.kind === 'pending_verification';
  return (
    <Badge colorPalette={pending ? 'orange' : 'green'} variant="subtle" size="sm">
      {t(pending ? 'commissions.rewards.pendingVerification' : 'commissions.rewards.newCustomer')}
    </Badge>
  );
}
